import { useEffect, useState } from 'react';
import './employerSelection.scss';
import SearchIcon from '../../../assets/icons/searchIcon.svg';
import GreenTick from '../../../assets/icons/greenSelectedTick.png';
import GreenDeselectedTick from '../../../assets/icons/greenDeselectedTick.png';
import DownArrow from '../../../assets/icons/arrowdown.svg';

interface IEmployee {
    url: string;
    name: string;
    selected: boolean;
    id: number;
}

interface IEmployeeRow {
    name: string;
    onSelection(): any;
    onDeselection(): any;
}

const EmployeeRow = ({ name, onSelection, onDeselection }: IEmployeeRow) => {
    const [selected, setSelected] = useState<boolean>(false);
    const changeValue = () => {
        setSelected(!selected);
        if (selected) {
            void onDeselection();
        } else {
            void onSelection();
        }
    };

    return (
        <div
            className="employerSelectionComponentRow"
            onClick={() => {
                changeValue();
            }}
        >
            <div className="left">
                <div className="image">{name.slice(0, 2)}</div>
                <div className="name">{name}</div>
            </div>
            <div className="right">
                {selected ? (
                    <img src={GreenTick} alt="" className="image" />
                ) : (
                    <img src={GreenDeselectedTick} alt="" className="image" />
                )}
            </div>
        </div>
    );
};

const employerSelection = () => {
    const [showDropDown, setShowDropDown] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<string>('');
    const [selectedEmployeesCount, setSelectedEmployeesCount] = useState<number>(0);

    return (
        <div className="employerSelectionComponent">
            <div
                className="selectionButton"
                onClick={() => {
                    setShowDropDown(!showDropDown);
                }}
                style={{ backgroundColor: showDropDown ? '' : '#F0F8F6' }}
            >
                <div className="left">필터({selectedEmployeesCount})</div>

                <div className="right">
                    <img src={DownArrow} alt="" />
                </div>
            </div>
            <div className="dropDownWrapper">
                <div className="dropDown" hidden={!showDropDown}>
                    <div className="searchBox">
                        <input
                            type="text"
                            value={searchText}
                            onChange={(e) => {
                                setSearchText(e.target.value);
                            }}
                        />
                        <img src={SearchIcon} alt="" />
                    </div>

                    <div className="textRow">
                        <div className="left">직원을 선택하세요</div>
                        <div className="right">초기화</div>
                    </div>
                    <div className="employeeList">
                        <EmployeeRow
                            name="홍직원"
                            onSelection={() => {
                                setSelectedEmployeesCount(selectedEmployeesCount + 1);
                            }}
                            onDeselection={() => {
                                setSelectedEmployeesCount(selectedEmployeesCount - 1);
                            }}
                        />

                        <EmployeeRow
                            name="홍직원"
                            onSelection={() => {
                                setSelectedEmployeesCount(selectedEmployeesCount + 1);
                            }}
                            onDeselection={() => {
                                setSelectedEmployeesCount(selectedEmployeesCount - 1);
                            }}
                        />

                        <EmployeeRow
                            name="홍직원"
                            onSelection={() => {
                                setSelectedEmployeesCount(selectedEmployeesCount + 1);
                            }}
                            onDeselection={() => {
                                setSelectedEmployeesCount(selectedEmployeesCount - 1);
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default employerSelection;
